// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var ViewStack = require("../../../../reason/common/ViewStack.bs.js");
var Text__Jsx3 = require("../../../../uikit/reason/helpers/Text__Jsx3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var PropertyAddressValidationCallout = require("./PropertyAddressValidationCallout.bs.js");

function GeocodingError(props) {
  return JsxRuntime.jsx(PropertyAddressValidationCallout.make, {
              heading: "We could not verify the address",
              children: JsxRuntime.jsx(ViewStack.make, {
                    p: "sm",
                    children: Caml_option.some(JsxRuntime.jsxs(Text__Jsx3.make, {
                              as_: "div",
                              children: [
                                props.reason === "OutsideChapterBoundaries" ? "The address you entered is not within the boundaries of your chapter." : "We were unable to locate the address. Please check the address you entered above.",
                                JsxRuntime.jsx("br", {}),
                                JsxRuntime.jsx("br", {}),
                                "If you have any questions, just ask for help using our messenger in the lower-right corner"
                              ]
                            }))
                  }),
              icon: "Error"
            });
}

var make = GeocodingError;

exports.make = make;
/* ViewStack Not a pure module */
